import React from 'react'

export default function Footer() {
  return (
    <div className='InterFont Footer'><a href="https://twitter.com/kshik_" target="_blank">Twitter: @kshik</a></div>
  )
}
